import React from "react";
import { ImageUploadField } from "../../shared/ImageUploadField";
import { DetailContentModePicker } from "./DetailContentModePicker";
import { DetailSectionsEditor } from "./DetailSectionsEditor";
import { RichContentEditorSection } from "./RichContentEditorSection";
import { blogInputClass } from "./BlogEditorFormFields";

export const defaultProjectForm = {
  id: 0,
  customerId: "",
  code: "",
  name: "",
  description: "",
  location: "",
  content: "",
  detailContentMode: "html",
  sectionsJson: "",
  image: "",
  order: 0,
  inactive: false
};

const fieldLabelClass = "mb-1.5 block text-xs font-medium text-slate-600";

export function ProjectEditorFormFields({
  form,
  setForm,
  isAdmin,
  customers,
  htmlMode,
  setHtmlMode
}) {
  return (
    <div className="space-y-4">
      {isAdmin ? (
        <div>
          <label className={fieldLabelClass} htmlFor="project-customer">
            Customer <span className="text-red-500">*</span>
          </label>
          <select
            id="project-customer"
            required
            className={blogInputClass}
            value={form.customerId}
            onChange={(e) => setForm((f) => ({ ...f, customerId: e.target.value }))}
          >
            <option value="">— Select —</option>
            {customers.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name} {c.code ? `(${c.code})` : ""}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label className={fieldLabelClass}>Project code</label>
          <input
            className={blogInputClass}
            value={form.code}
            onChange={(e) => setForm((f) => ({ ...f, code: e.target.value }))}
          />
        </div>
        <div>
          <label className={fieldLabelClass}>Order</label>
          <input
            className={blogInputClass}
            type="number"
            value={form.order}
            onChange={(e) => setForm((f) => ({ ...f, order: e.target.value }))}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div>
          <label className={fieldLabelClass}>
            Name <span className="text-red-500">*</span>
          </label>
          <input
            className={blogInputClass}
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            required
          />
        </div>
        <div>
          <label className={fieldLabelClass}>Location</label>
          <input
            className={blogInputClass}
            value={form.location}
            onChange={(e) => setForm((f) => ({ ...f, location: e.target.value }))}
          />
        </div>
      </div>

      <div>
        <label className={fieldLabelClass}>Description</label>
        <textarea
          className={blogInputClass}
          rows={3}
          value={form.description}
          onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
        />
      </div>

      <ImageUploadField
        label="Image"
        value={form.image}
        onChange={(v) => setForm((f) => ({ ...f, image: v }))}
        labelClassName={fieldLabelClass}
      />

      <label className="flex items-center gap-2 text-sm text-slate-700">
        <input
          type="checkbox"
          checked={!!form.inactive}
          onChange={(e) => setForm((f) => ({ ...f, inactive: e.target.checked }))}
        />
        Inactive (hidden on website)
      </label>

      <DetailContentModePicker
        value={form.detailContentMode}
        onChange={(detailContentMode) => setForm((f) => ({ ...f, detailContentMode }))}
      />

      {form.detailContentMode === "json" ? (
        <DetailSectionsEditor form={form} setForm={setForm} />
      ) : (
        <RichContentEditorSection
          form={form}
          setForm={setForm}
          htmlMode={htmlMode}
          setHtmlMode={setHtmlMode}
          label="Landing page content (HTML)"
          fieldId="project-content"
          description="Blog-style freeform landing page — headings, text, images, tables, columns, and buttons."
        />
      )}
    </div>
  );
}
